import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {TaxesActions} from '../store';
import {TaxesSelectors} from '../store/selectors';

@Injectable()
export class TaxesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadTaxesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadTaxesDone() {

    return this.store.pipe(
      select(TaxesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(TaxesActions.ReadTaxes());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
